module.exports = __webpack_public_path__ + "static/img/ic_elementary_on@2x.7850ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_elementary_on@2x.png
// module id = urgj
// module chunks = 1